import React from 'react';
import { useState, useEffect } from 'react';

import t from '../Translation/Translation';
import { IonButtons, IonContent, IonHeader, IonFooter, IonPage, IonTitle, IonToolbar, IonButton, IonIcon, IonMenuToggle, IonLabel } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import { Loader } from 'citric_components';
import SummaryMin from '../Summary/SummaryMin';

import { App } from '@capacitor/app';

import { Avatar, CustomTable } from 'citric_components';
import Menubar from '../Dashboard/Menubar';

import CardImg from '../../images/card.png';
import { useNavigate, useLocation } from 'react-router';

import conf from '../../config.json';
import { generateKey, logD } from '../Util/Util';
import Header from '../Dashboard/Header';

export default function LaunchsInterviewed(props) {
    logD("Launchs", props);
    const launchs = props.project.launchsDash;

    var hiddenColumns = ['idLaunch', 'summary'];

    const navigate =useNavigate();

    function back() {
        
        //setResponses(null);
        //props.setLaunch(null);
        setTimeout(function(){
            navigate(-1);
        }, 1);
        //navigate.go(-1);
    }

    App.addListener('backButton', ({canGoBack}) => {
          
          if(!canGoBack){
            App.exitApp();
          } else {
            back();
          }
    });

    

    const columns = [
        {
            Header: t('id'),
            accessor: 'idLaunch',
        },
        {
            Header: t('actions'),
            id: 'actions',
            accessor: (d) => {
                return <>
                    <IonButton color="primary" onClick={ (e) => { 
                        e.preventDefault();
                        var keyNote = generateKey(d.idLaunch);
                        props.setKeyNote(keyNote);
                        //props.setUrl(conf.Vprotocol + '://' + conf.Vhost + ':' + conf.Vport + '/' + conf.Vcontext + '/answer/a/' + d.urls[0].data + "?note=" + keyNote + "&usuario=" + props.token.u);
                        if(props.response != null) {
                            props.setUrl(conf.Vprotocol + '://' + conf.Vhost + ':' + conf.Vport + '/' + conf.Vcontext + '/answer/e?elem=form&accion=cargar&planificacion=' + d.idLaunch + '&usuario=' + props.token.u + '&cuestionario=' + props.response +'&origen=email');
                        } else if(d.responses.length > 0) {
                            props.setResponse(d.responses[d.responses.length - 1].idResponse);
                            props.setUrl(conf.Vprotocol + '://' + conf.Vhost + ':' + conf.Vport + '/' + conf.Vcontext + '/answer/e?elem=form&accion=cargar&planificacion=' + d.idLaunch + '&usuario=' + props.token.u + '&cuestionario=' + d.responses[d.responses.length - 1].idResponse +'&origen=email');
                        } else {
                            props.setUrl(conf.Vprotocol + '://' + conf.Vhost + ':' + conf.Vport + '/' + conf.Vcontext + '/answer/e?elem=form&accion=empezar&planificacion=' + d.idLaunch + '&usuario=' + props.token.u +'&origen=email');
                        }
                        
                        props.setTitle(props.project.name);
                        props.setTypeUrl('survey_start');
                        if(props.token.r != 4) {
                            props.setInterviewer(d.urls[0].idUser);
                        }
                        props.setInterviewed(props.token.u);
                        
                        setTimeout(function(){
                            navigate('../webview/'+d.idLaunch);
                        }, 100);
                    }}>{t('start_survey')}</IonButton>
                </>
            }
        },
        {
            id: 'survey',
            Header: t('survey'),
            accessor: (d) => {
                return d.release.name
            }
        },
        {
            id: 'start',
            Header: t('start'),
            sortType: (a, b) => {
                return b.original.start - a.original.start;
            },
            accessor: (d) => {
                if(d.start == null) {
                    return '';
                } else {
                    return new Date(d.start).toLocaleString(navigator.language);
                }
            },

        }, {
            id: 'end',
            Header: t('end'),
            sortType: (a, b) => {
                return b.original.end - a.original.end;
            },
            accessor: (d) => {
                if(d.end == null) {
                    return '';
                } else {
                    return new Date(d.end).toLocaleString(navigator.language);
                }
            },
        },
        {
            id: 'summary',
            accessor: (d) => {
                //console.log(d);
                /*if(props.token.r != 4) {
                    const summaryData = {};
                    summaryData.id_form = release.idDraft;
                    summaryData.plannings = [d.idLaunch];
                    summaryData.lang_code = "ES";
                    return <SummaryMin data={summaryData} lang={"ES"} loi={false} handleError={props.handleError}/>
                }*/
                //return '';
            },
        }
    ];

    return (
        <>
            { props.projects.length == 1 && <Menubar lang={props.lang} setLang={props.setLang} token={props.token} setToken={props.setToken} contentId="responses"/> }
            <IonPage id="responses">
                <IonHeader>
                    <Header lang={props.lang} setLang={props.setLang} token={props.token} setToken={props.setToken}/>
                    {/*<IonToolbar className="toolbar-azul">
                        <IonButtons slot="start">
                        { props.projects.length == 1 &&
                            <IonMenuToggle className="ion-padding-start">
                                <Avatar name={props.token.name.charAt(0).toUpperCase()}/>
                            </IonMenuToggle>
                        }
                        { props.projects.length > 1 &&
                            <IonButton onClick={() => back()}><IonIcon icon={arrowBack}></IonIcon></IonButton>
                        }
                        </IonButtons>
                        <IonTitle>{props.project.name}</IonTitle>
                    </IonToolbar>*/}
                </IonHeader>
                <IonContent className="ion-padding">
                    {
                        launchs != null &&
                        <>
                           <CustomTable keyField='start' desc={false} data={launchs} columns={columns} isFilter={true} isPagination={false} isSelection={false} hasActions={false} hiddenColumns={hiddenColumns} />
                        </>
                    }
                </IonContent>
                <IonFooter>
                    <IonToolbar>
                        <IonTitle className="text-center">{t('logged_in_as')} <span className='color-orange'><b>{props.token.name}</b></span></IonTitle>
                    </IonToolbar>
                </IonFooter>
            </IonPage>
        </>
    );
}